import React from "react";
import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import { AuthProvider, useAuth } from "./context/AuthContext";
import { ThemeProvider } from "./context/ThemeContext";

// Pages
import Landing from "./pages/Landing";
import Login from "./pages/Login";
import Register from "./pages/Register";
import Dashboard from "./pages/Dashboard";
import MyScripts from "./pages/MyScripts";
import ForgotPassword from "./pages/ForgotPassword";
import ResetPassword from "./pages/ResetPassword";
import Pricing from "./pages/Pricing";
import PaymentVerify from "./pages/PaymentVerify";
import Team from "./pages/Team";
import AcceptInvitation from "./pages/AcceptInvitation";
import VideoCredits from "./pages/VideoCredits";
import InstallPrompt from "./components/InstallPrompt";

const PrivateRoute = ({ children }: { children: React.ReactNode }) => {
  const { isAuthenticated, loading } = useAuth();
  if (loading)
    return (
      <div className="flex items-center justify-center h-screen bg-gray-900 text-white">
        Loading...
      </div>
    );
  return isAuthenticated ? <>{children}</> : <Navigate to="/login" />;
};

const App = () => {
  return (
    <ThemeProvider>
      <AuthProvider>
        <Router>
          <Routes>
            <Route path="/" element={<Landing />} />
            <Route path="/login" element={<Login />} />
            <Route path="/register" element={<Register />} />
            <Route path="/forgot-password" element={<ForgotPassword />} />
            <Route path="/reset-password" element={<ResetPassword />} />
            <Route path="/pricing" element={<Pricing />} />
            <Route path="/payment/verify" element={<PaymentVerify />} />

            <Route
              path="/dashboard"
              element={
                <PrivateRoute>
                  <Dashboard />
                </PrivateRoute>
              }
            />
            <Route
              path="/team"
              element={
                <PrivateRoute>
                  <Team />
                </PrivateRoute>
              }
            />
            <Route path="/team/accept" element={<AcceptInvitation />} />
            <Route
              path="/my-scripts"
              element={
                <PrivateRoute>
                  <MyScripts />
                </PrivateRoute>
              }
            />
            {/* VIDEO: buy video credits (logged-in users only) */}
            <Route
              path="/video-credits"
              element={
                <PrivateRoute>
                  <VideoCredits />
                </PrivateRoute>
              }
            />
          </Routes>
          <InstallPrompt />
        </Router>
      </AuthProvider>
    </ThemeProvider>
  );
};

export default App;
